import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Card, CardText, CardTitle } from "react-md";
import { checkIfEmpty } from "components/Shared/Formatters";
import ReactTooltip from "react-tooltip";
import { NOT_PROVIDED } from "typeConstants/stringConstants";

class UserField extends Component {
  // PropDoc
  //
  //
  //  If the fieldValue is equal to the disabledFieldValue then the component will appear disabled
  //
  // dialogContents = [
  //   {fieldTitle, fieldValue}
  // ]

  //ctr
  constructor(props) {
    super(props);
    this.renderDialogContents = this.renderDialogContents.bind(this);
    this.checkIfDisabled = this.checkIfDisabled.bind(this);
    this.tooltip = this.tooltip.bind(this);
    this.checkIfEmail = this.checkIfEmail.bind(this);
    this.state = {
      disabled: false
    };
  }

  //lifecycle
  UNSAFE_componentWillReceiveProps() {
    this.checkIfDisabled();
  }

  checkIfDisabled() {
    if (
      (this.props.disabledFieldValue === this.props.fieldValue ||
        !this.props.fieldValue) &&
      this.state.disabled === false
    ) {
      this.setState({ disabled: true });
    } else {
      this.setState({
        disabled: false
      });
    }
  }

  checkIfEmail(fieldTitle, fieldValue) {
    if (fieldTitle.toUpperCase().includes("EMAIL")) {
      return (
        <a
          className="caseheader-contactinfo-tooltip-hyperlink"
          href={"mailto:" + fieldValue}
        >
          {checkIfEmpty(fieldValue)}
        </a>
      );
    }
    return checkIfEmpty(fieldValue);
  }

  renderDialogContents() {
    if (this.props.dialogContents) {

      return(
        <div className="tipped-cell-tip">
          <Card className="card-unnested">
              <CardTitle title={this.props.tooltipTitle}/>
              <CardText>
              <div className="md-grid">
                  <span className="tipped-cell-label md-cell--6">
                  {
                  this.props.dialogContents.map(field => {
                    if(field.fieldValue === NOT_PROVIDED) {
                      return;
                    }
                    return (
                      <div className="field-label" key={`${field.fieldTitle} ${field.fieldValue} label`}> 
                        {field.fieldTitle}
                      </div>
                    );
                  })
                  }
                  </span>
                  <span className="tipped-cell-value md-cell--6">
                  {
                  this.props.dialogContents.map(field => {
                    if(field.fieldValue === NOT_PROVIDED) {
                      return;
                    }
                    return(
                      <div className="field-value" key={`${field.fieldTitle} ${field.fieldValue} value`}> 
                      {this.checkIfEmail(field.fieldTitle, field.fieldValue)}
                    </div>
                    );
                  })
                  }
                  </span>
                </div>
              </CardText>
          </Card>
        </div>
    );
    }
    return;
  }

  tooltip() {
    if (this.props.dialogContents) {
      return (
        <div data-tip data-for={this.props.fieldTitle + "-tooltip"}>
          <ReactTooltip
            id={this.props.fieldTitle + "-tooltip"}
            effect="solid"
            place="right"
            delayHide={100}
            className="m-tooltip"
            scrollHide={true}
            border={true}
          >
            {this.renderDialogContents()}
          </ReactTooltip>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="md-cell--6 md-text-field-container md-full-width md-text-field-container--disabled md-text-field-container--input user-field">
        <div className="md-floating-label--disabled">
          {this.props.fieldTitle}
        </div>

        <span data-tip data-for={this.props.fieldTitle + "-tooltip"}>
          <Button
            disabled={this.state.disabled}
            className="appraiser-caseheader-button"
            flat
          >
            {checkIfEmpty(this.props.fieldValue)}
          </Button>
        </span>
        {this.state.disabled === false && this.tooltip()}
      </div>
    );
  }
}

UserField.propTypes = {
  fieldTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  tooltipTitle: PropTypes.string,
  fieldValue: PropTypes.string,
  dialogContents: PropTypes.array,
  disabledFieldValue: PropTypes.string
};

export default UserField;
